<template>
    <div class="element-content">
        <div v-if="['article', 'video'].includes(element.type)">
            <l-learning-element-content :element="element" />
        </div>
        <div v-else-if="element.type === 'task'">
            <l-learning-element-task :contact="element.taggedUsers" />
        </div>
        <div v-else-if="element.type === 'quiz'">
            <l-learning-element-quiz
                :questions="element.questions"
                :option-select-disabled="optionSelectDisabled"
                :toggle-correct-option="toggleCorrectOption"
                :incorrect-answers="incorrectAnswers"
            />

            <!-- Quiz Error -->
            <div v-show="quizError" data-test-id="quiz-error">
                <l-text-alert type="danger" :text="$t('learning.progress.todo.error.quiz')" />
                <hr />
            </div>
            <!--/Quiz Error -->
        </div>
        <div v-else>
            {{ $t("learning.admin.element.type.notRecognized", { type: element.type }) }}
        </div>
    </div>
</template>

<script>
import LTextAlert from "@/components/LTextAlert";

import LLearningElementContent from "@/components/LLearningElementContent";
import LLearningElementQuiz from "@/components/LLearningElementQuiz";
import LLearningElementTask from "@/components/LLearningElementTask";

export default {
    components: {
        LTextAlert,

        LLearningElementContent,
        LLearningElementQuiz,
        LLearningElementTask,
    },
    props: {
        element: {
            type: Object,
            required: true,
        },
        // Quiz-related options
        optionSelectDisabled: {
            type: Boolean,
            default: false,
        },
        toggleCorrectOption: {
            type: Function,
            default: () => {},
        },
        quizError: {
            type: Boolean,
            default: false,
        },
        incorrectAnswers: {
            type: Array,
            default: () => [],
        },
    },
    // A `data` property is needed so that this file is taken into account by jest's code coverage
    // (cf. https://github.com/vuejs/vue-jest/issues/32)
    //
    data() {
        return {};
    },
};
</script>

<style scoped></style>
